/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useLocation } from 'js/lib/useRouter';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import PageNavLink from 'bundles/page-header/components/page-navigation/PageNavLink';
import PageNavigation from 'bundles/page-header/components/page-navigation/PageNavigation';
import type { PageNavLink as PageNavLinkType } from 'bundles/unified-common/hooks/useEnterprisePageHeaderLinks';

const styles = {
  navContainer: css`
    > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  `,
  subNav: css`
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  `,
};

type Props = {
  subnavLinks?: PageNavLinkType[];
};

const DefaultEnterpriseSubNavigation = ({ subnavLinks }: Props) => {
  const location = useLocation();

  if (!subnavLinks || (subnavLinks && subnavLinks.length === 0)) {
    return null;
  }

  return (
    <PageGridContainer css={styles.navContainer}>
      <Grid item xs={12} css={styles.subNav}>
        <PageNavigation>
          {subnavLinks.map((navLink) => {
            const hrefWithoutQuery = navLink.href.split('?')[0];

            return (
              <PageNavLink
                key={navLink.href}
                label={navLink.label}
                name={navLink.label.toLowerCase()}
                href={navLink.href}
                isCurrent={location.pathname === hrefWithoutQuery}
              />
            );
          })}
        </PageNavigation>
      </Grid>
    </PageGridContainer>
  );
};

export default DefaultEnterpriseSubNavigation;
